import React from 'react';
import { Link, SubtleText } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';
import { linkTo } from '@99designs/routing';

type PrivacyPolicyStatementProps = {
    openInNewTab?: boolean;
};

export function PrivacyPolicyStatement({ openInNewTab }: PrivacyPolicyStatementProps) {
    return (
        <SubtleText>
            <FormattedReactMessage
                message={__(
                    'For more details on how we use your information, please read our <Link>Privacy and Cookie Policy</Link>.'
                )}
                replacements={{
                    Link: (
                        <Link
                            data-testid="privacy-policy-link"
                            color="grey700"
                            size="size2"
                            href={linkTo.privacyPolicy()}
                            openInNewTab={openInNewTab}
                        />
                    ),
                }}
            />
        </SubtleText>
    );
}
